import { render, staticRenderFns } from "./Templates.yaml?vue&type=template&id=24c7a362&component"
import script from "./Templates.yaml?vue&type=script&lang=ts&component"
export * from "./Templates.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports